module.exports = __webpack_public_path__ + "static/media/logo.9734ed62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo.svg
// module id = 226
// module chunks = 0